/** Cliente HTTP mínimo: mesma origem (proxy no Vite, Fastify em produção), cookie de sessão. */

export class ErroApi extends Error {
  constructor(public readonly status: number, message: string, public readonly codigo?: string, public readonly detalhes?: unknown) {
    super(message);
    this.name = 'ErroApi';
  }
}

interface Opcoes {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  query?: Record<string, string | number | boolean | undefined | null | Array<string | number>>;
  signal?: AbortSignal;
}

export async function api<T = unknown>(caminho: string, o: Opcoes = {}): Promise<T> {
  const url = new URL(caminho, window.location.origin);
  if (o.query) {
    for (const [k, v] of Object.entries(o.query)) {
      if (v == null || v === '') continue;
      if (Array.isArray(v)) v.forEach((x) => url.searchParams.append(k, String(x)));
      else url.searchParams.set(k, String(v));
    }
  }
  const r = await fetch(url, {
    method: o.method ?? 'GET',
    headers: o.body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: o.body !== undefined ? JSON.stringify(o.body) : undefined,
    credentials: 'same-origin',
    signal: o.signal,
  });
  const texto = await r.text();
  const dados = texto ? (JSON.parse(texto) as unknown) : null;
  if (!r.ok) {
    const e = (dados ?? {}) as { erro?: string; codigo?: string; detalhes?: unknown };
    if (r.status === 401 && !caminho.startsWith('/v1/auth/') && !caminho.startsWith('/v1/portal/')) {
      window.dispatchEvent(new CustomEvent('sgc:sem-sessao'));
    }
    throw new ErroApi(r.status, e.erro ?? `erro ${r.status}`, e.codigo, e.detalhes);
  }
  return dados as T;
}

export const get = <T,>(c: string, query?: Opcoes['query']) => api<T>(c, { query });
export const post = <T,>(c: string, body?: unknown) => api<T>(c, { method: 'POST', body });
export const put = <T,>(c: string, body?: unknown) => api<T>(c, { method: 'PUT', body });
export const del = <T,>(c: string) => api<T>(c, { method: 'DELETE' });

/** Envia um arquivo (multipart, campo "arquivo"); mesma sessão por cookie. */
export async function upload<T = unknown>(caminho: string, arquivo: File, campos?: Record<string, string>): Promise<T> {
  const fd = new FormData();
  for (const [k, v] of Object.entries(campos ?? {})) fd.append(k, v);
  fd.append('arquivo', arquivo, arquivo.name);
  const r = await fetch(new URL(caminho, window.location.origin), { method: 'POST', body: fd, credentials: 'same-origin' });
  const texto = await r.text();
  const dados = texto ? (JSON.parse(texto) as unknown) : null;
  if (!r.ok) {
    const e = (dados ?? {}) as { erro?: string; codigo?: string };
    throw new ErroApi(r.status, e.erro ?? `erro ${r.status}`, e.codigo);
  }
  return dados as T;
}
